import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card col mx-4 mt-2" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "stat-widget-five grid" }
const _hoisted_4 = { class: "material-icons mr-3" }
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = { class: "stat-content flex align-items-center" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "stat-text" }
const _hoisted_9 = { class: "flex text-surface-900 text-5xl font-semi-bold mt-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["stat-icon flex justify-content-start mx-2", _ctx.colorClass])
        }, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.icon), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.title), 1)
        ], 2),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.value), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}